export default __webpack_public_path__ + "static/media/559.30c4e344.gif";